module.exports = __webpack_public_path__ + "img/w6.34305f3f.jpg";